import CasFormInput from '@cas/components/inputs/cas-form-input/CasFormInput';
import { useTranslation } from 'react-i18next';
import { useWatch } from 'react-hook-form';
import CasFormDropdown from '@cas/components/inputs/cas-form-dropdown/CasFormDropdown';
import CasFormConditionalInput from '@cas/components/inputs/cas-form-conditional-input/CasFormConditionalInput';
import { GeofenceTypeV2, GeofenceFormModel } from '@casops/store/apis/geofencesApi';
import CasFormMultiselect from '@cas/components/inputs/cas-form-multiselect/CasFormMultiselect';
import useFenceTypeOptions from './useFenceTypeOptions';
import useAssetGroupOptions from './useAssetGroupOptions';
import useAreaOptions from './useAreaOptions';
import useStyleOptions from './useStyleOptions';
import { UseGeofenceFormTabsProps } from '../form/useGeofenceFormTabs';
import CasFormConditionalDisplay from '@cas/components/inputs/cas-form-conditional-display/CasFormConditionalDisplay';
import { ReactElement } from 'react';

type FormModel = GeofenceFormModel;

export function GeneralControls({
  control,
  resetField,
  isReadonly,
}: UseGeofenceFormTabsProps<FormModel>): ReactElement {
  const { t } = useTranslation();

  const watchFenceTypes = useWatch({ control, name: 'fts' });

  const styleOptions = useStyleOptions();

  return (
    <>
      <CasFormInput
        control={control}
        name="name"
        label={t('Fields.GeofenceName')}
        isReadonly={isReadonly}
      />
      <CasFormInput
        control={control}
        name="desc"
        label={t('Fields.Description')}
        element="textarea"
        isReadonly={isReadonly}
      />
      <CasFormMultiselect<FormModel, GeofenceTypeV2>
        control={control}
        name="fts"
        label={t('Fields.GeofenceTypes')}
        useItemsHook={useFenceTypeOptions}
        enableSelectAll={false}
        isReadonly={isReadonly}
      />
      <CasFormConditionalDisplay
        show={watchFenceTypes.includes(GeofenceTypeV2.WetRoad)}
        name="wetDuration"
        resetField={resetField}
      >
        <CasFormInput
          control={control}
          name="wetDuration"
          type="number"
          label={t('Fields.WetDuration')}
          isReadonly={isReadonly}
        />
      </CasFormConditionalDisplay>
      <CasFormDropdown
        control={control}
        name="stid"
        label={t('Fields.StyleName')}
        items={styleOptions}
        isReadonly={isReadonly}
      />
      <CasFormMultiselect<FormModel, number>
        control={control}
        name="ags"
        label={t('Fields.AssetGroup')}
        useItemsHook={useAssetGroupOptions}
        enableSelectAll={true}
        isReadonly={isReadonly}
      />
      <CasFormMultiselect<FormModel, number>
        control={control}
        name="rules.areaIds"
        label={t('Fields.Areas')}
        useItemsHook={useAreaOptions}
        isReadonly={isReadonly}
      />
      <CasFormConditionalInput
        control={control}
        name="followMeName"
        label={t('Fields.FollowMe')}
        isReadonly={isReadonly}
      />
    </>
  );
}

export default GeneralControls;
